// extracted by mini-css-extract-plugin
export default {"clearIcon":"WMFi3bRks6AHsu20X0Nq","unified":"fpHU8RX8C_EwoAW1ahwT","SearchTextField--dark":"K1oqQuVG2OgDUrSfdPWQ"};